export default function CardTitleText({
  cardTitle,
  cardText,
}: {
  cardTitle: string;
  cardText: string;
}) {
  return (
    <div>
      <h1 className="text-primary mb-3 font-semibold uppercase lg:items-center">
        {cardTitle}
      </h1>
      <p className="w-full text-xl">{cardText}</p>
    </div>
  );
}
